import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const Row = ({ a, name, onDelete }) => {
  const [confirming, setConfirming] = useState(false);
  const del = async () => {
    try {
      await api.delete(`/activity/${a.id}`);
      onDelete(a.id);
      toast.success("Entry deleted");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <tr data-testid={`activity-row-${a.id}`}>
      <td className="log-first">{fmtDate(a.date)}</td>
      <td data-testid={`activity-row-setter-${a.id}`}>{name}{a.is_sample && <span className="sample-chip ml-2">Sample</span>}</td>
      <td data-testid={`activity-row-dials-${a.id}`} className="text-right font-mono">{a.dials}</td>
      <td data-testid={`activity-row-conversations-${a.id}`} className="text-right font-mono">{a.conversations}</td>
      <td data-testid={`activity-row-declined-${a.id}`} className="text-right font-mono">{a.declined_to_book}</td>
      <td className="text-right">
        {confirming ? (
          <span className="inline-flex gap-1">
            <button type="button" data-testid={`activity-delete-confirm-btn-${a.id}`} onClick={del} className="btn-subtle h-8 text-xs">Confirm</button>
            <button type="button" onClick={() => setConfirming(false)} className="btn-ghost h-8 text-xs">Cancel</button>
          </span>
        ) : (
          <button type="button" data-testid={`activity-delete-btn-${a.id}`} onClick={() => setConfirming(true)} className="btn-ghost h-8 text-xs">Delete</button>
        )}
      </td>
    </tr>
  );
};

export const ActivityList = ({ entries, repsById, onDelete }) => (
  <div className="max-h-[60vh] overflow-auto rounded-2xl border border-slate-800 bg-slate-900" data-testid="activity-table">
    <table className="log-table">
      <thead><tr><th className="log-first">Date</th><th>Setter</th><th className="text-right">Dials/DMs</th><th className="text-right">Conversations</th><th className="text-right">Declined to Book</th><th /></tr></thead>
      <tbody>
        {entries.map((a) => <Row key={a.id} a={a} name={repsById[a.setter_id]?.name || "Unknown rep"} onDelete={onDelete} />)}
      </tbody>
    </table>
    {entries.length === 0 && <p data-testid="activity-empty" className="py-10 text-center text-sm text-slate-400">No activity logged yet</p>}
  </div>
);
